(function(){
  var view=document.getElementById('ugcView');if(!view)return;
  var slides=view.querySelectorAll('img'),dotsBox=document.getElementById('ugcDots');
  if(!dotsBox||!slides.length)return;

  dotsBox.innerHTML=''; // clear any existing dots so count always matches photo count

  var idx=0,timer;
  slides.forEach(function(_,i){var b=document.createElement('button');b.setAttribute('aria-label','Photo '+(i+1));b.onclick=function(){idx=i;go(true);};dotsBox.appendChild(b);});
  var dots=dotsBox.querySelectorAll('button');
  function go(manual){
    var s=slides[idx];view.scrollTo({left:s.offsetLeft-view.offsetLeft,behavior:'smooth'});
    dots.forEach(function(d,i){d.className=i===idx?'on':'';});
    if(manual){clearInterval(timer);start();}
  }
  function start(){timer=setInterval(function(){idx=(idx+1)%slides.length;go(false);},3200);}
  view.addEventListener('mouseenter',function(){clearInterval(timer);});
  view.addEventListener('mouseleave',start);
  go(false);start();
})();